import HeaderTitleContent from '../../../common/components/atom/HeaderTitleContent/HeaderTitleContent'
import Table from '../../../common/components/molecule/Table/Table'

export default function DashboardListPage() {
  return (
    <div>
    <HeaderTitleContent>Dashboard</HeaderTitleContent>
    <Table 
      headerTitle={['Dashboard', 'Description']}
      emptyMessage='Aucun Dashboard'
    />
    </div>
  )
}
